// The two MD5 contracts existing accounts and wins depend on (.ai/rewrite-notes.md 2.5.1).
import SparkMD5 from 'spark-md5';

export const md5 = (s: string): string => SparkMD5.hash(s);

/** The client password hash: what the server ever sees and what localStorage keeps (player.js:26). */
export const clientHash = (password: string): string => md5('$vx78V";w2' + password);

/** Win anti-cheat hash (statsWin.js ___): the three numbers are ADDED, prev_deal is 0/1. */
export function winHash(gameType: string, scoringType: string, time: number, score: number, moves: number, prevDeal: 0 | 1): string {
  return md5(`${gameType}/${scoringType.charAt(0)}${time + score + moves}${prevDeal}:"45md$%`);
}
